import React from 'react';
import CampaignsAtlas from './CampaignsAtlas';
import './CampaignsArea.css';

/**
 * Campaigns home — Atlas of campaigns. Recents live on the + New Tab page.
 */
const CampaignsArea = ({
  sprints,
  sprintOrder,
  onSelectSprint,
  onOpenInNewTab,
  onRenameSprint,
  onTrashSprint,
  openCreateSprintModal,
  openCreateNestedSprintModal,
}) => (
  <div className="campaigns-area">
    <CampaignsAtlas
      sprints={sprints}
      sprintOrder={sprintOrder}
      onSelectSprint={onSelectSprint}
      onOpenInNewTab={onOpenInNewTab}
      onRenameSprint={onRenameSprint}
      onTrashSprint={onTrashSprint}
      openCreateSprintModal={openCreateSprintModal}
      openCreateNestedSprintModal={openCreateNestedSprintModal}
    />
  </div>
);

export default CampaignsArea;
